import React from 'react'
import { Box, Link } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Spinner } from 'packages/eid-ui'

const useStyles = makeStyles({
    root: (props) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '5px',
        width: props.width,
        minHeight: props.height,
        paddingLeft: '8px',
        paddingRight: props.paddingRight || '8px',
        backgroundColor: props.disabled ? '#d0d9e2' : props.bgColor,
        border: props.border,
        color: props?.fontColor ? props.fontColor : '#ffffff',
        height: 'unset !important',
        paddingTop: '10px',
        paddingBottom: '10px',
        '&:hover': {
            cursor: props.disabled ? 'initial' : 'pointer',
            backgroundColor: props.hoverColor,
        },
    }),
})

const DrawerActionButton = (props) => {
    const {
        width,
        height,
        bgColor,
        hoverColor,
        border,
        fontColor,
        children,
        loading,
        onClick,
        disabled,
        loaderColor,
        paddingRight,
    } = props
    const classes = useStyles({
        width,
        height,
        bgColor,
        border,
        fontColor,
        hoverColor,
        disabled,
        paddingRight,
    })
    return (
        <Link
            component="button"
            underline="none"
            onClick={disabled ? undefined : onClick}
            style={{ width: width ? width : '100%' }}
        >
            <Box className={classes.root}>
                {loading && <Spinner size={0.8} color={loaderColor} />}
                {!loading && children}
            </Box>
        </Link>
    )
}

DrawerActionButton.defaultProps = {
    width: '100px',
    minHeight: '48px',
    bgColor: '#ffffff',
    border: 'none',
    loaderColor: '#ffffff',
}
export default DrawerActionButton
